"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _Answer = _interopRequireDefault(require("@insided/destination/icons/Answer"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var BestAnswer = function BestAnswer(_ref) {
  var bestAnswer = _ref.bestAnswer;
  var postUrl = typeof window !== 'undefined' ? "".concat(window.location.pathname, "/?postid=").concat(bestAnswer.publicReplyId, "#post").concat(bestAnswer.publicReplyId) : null;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('post__content', 'answer-field', 'qa-answer-field', 'best-answer-field')
  }, (0, _preact.h)(_Answer.default, {
    className: "icon--checkmark",
    width: 20,
    height: 20
  }), (0, _preact.h)("p", null, (0, _preact.h)("strong", {
    className: "best-answer-label"
  }, (0, _preact.h)(_phrase.default, {
    p: "Best answer by",
    m: "Forum"
  }), " ", bestAnswer.username)), (0, _preact.h)(_Content.default, {
    content: bestAnswer.content,
    className: "best-answer-reply__content"
  }), postUrl && (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(postUrl),
    className: "link link--underline"
  }, (0, _preact.h)(_phrase.default, {
    p: "View original",
    m: "Forum"
  })));
};

var _default = BestAnswer;
exports.default = _default;